import { setAccessToken } from 'api';
import { Reducer } from 'redux';
import { persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';

import { RESET } from 'action-creators/generic';
import {
  LOGIN_REQUEST,
  LOGIN_SUCCESSFUL,
  LOGIN_FAILURE,
  REFRESH_TOKEN_REQUEST,
  REFRESH_TOKEN_SUCCESSFUL,
  REFRESH_TOKEN_FAILURE,
  USER_LOGOUT,
  USER_LOGOUT_SUCCESSFUL,
  USER_LOGOUT_FAILURE,
  ACCOUNT_SUCCESSFUL,
  ACCOUNT_FAILURE,
  ACCOUNT_REQUEST,
  USER_ACCOUNT_DATA,
  REHYDRATE,
  OAUTH_EMAIL,
} from 'action-creators/user';

import { UserResponse, RefreshTokenResponse, AccountResponse } from '../models/user';

export interface UserState {
  isLoading: boolean;
  userResult: UserResponse | null;
  refreshTokenResult: RefreshTokenResponse | null;
  accountResult: AccountResponse | null;
  error: boolean | null;
  oAuthEmail: string | null;
}

const initialState: UserState = {
  isLoading: false,
  userResult: null,
  refreshTokenResult: null,
  accountResult: null,
  error: null,
  oAuthEmail: '',
};

const reducer: Reducer<UserState> = (state = initialState, action) => {
  switch (action.type) {
    case LOGIN_REQUEST:
      return {
        ...state,
        isLoading: true,
      };

    case LOGIN_SUCCESSFUL:
      return {
        ...state,
        userResult: action.payload,
        isLoading: false,
      };

    case LOGIN_FAILURE:
      return {
        ...state,
        userResult: null,
        error: action.payload,
        isLoading: false,
      };

    case USER_LOGOUT:
      return {
        ...state,
        accountResult: null,
        isLoading: true,
      };

    case USER_LOGOUT_SUCCESSFUL:
      return {
        ...state,
        userResult: null,
        refreshTokenResult: null,
        accountResult: null,
        error: null,
        isLoading: false,
      };

    case USER_LOGOUT_FAILURE:
      return {
        ...state,
        userResult: null,
        refreshTokenResult: null,
        accountResult: null,
        error: action.payload,
        isLoading: false,
      };

    case REFRESH_TOKEN_REQUEST:
      return {
        ...state,
        isLoading: true,
      };

    case REFRESH_TOKEN_SUCCESSFUL:
      return {
        ...state,
        refreshTokenResult: action.payload,
        isLoading: false,
      };

    case REFRESH_TOKEN_FAILURE:
      return {
        ...state,
        refreshTokenResult: null,
        error: action.payload,
        isLoading: false,
      };

    case ACCOUNT_REQUEST:
      return {
        ...state,
        isLoading: true,
      };

    case ACCOUNT_SUCCESSFUL:
      return {
        ...state,
        refreshTokenResult: null,
        isLoading: false,
        accountResult: action.payload,
      };

    case ACCOUNT_FAILURE:
      return {
        ...state,
        refreshTokenResult: null,
        error: action.payload,
        isLoading: false,
        accountResult: null,
      };

    case USER_ACCOUNT_DATA:
      const updateUserAccount = {
        ...state.accountResult,
        ...action.payload,
      };
      return {
        ...state,
        accountResult: updateUserAccount,
      };

    case REHYDRATE:
      if (action.payload?.userResult) {
        setAccessToken(action.payload.userResult.accessToken);
      }
      return {
        ...state,
        ...action.payload,
      };

    case OAUTH_EMAIL:
      return {
        ...state,
        oAuthEmail: action.payload,
      };

    case RESET: {
      return initialState;
    }

    default:
      return state;
  }
};

const persistConfig = {
  storage,
  version: 1,
  key: 'user',
  blacklist: ['isLoading', 'error'],
};

export default persistReducer(persistConfig, reducer);
